module.exports = __webpack_public_path__ + "static/media/IMG-20180411-WA0004-min.bb41e35a.jpg";